import * as React from 'react'

export interface ISearchIconProps {
  children: React.ReactNode
}

export const SearchIcon = ({ children }: ISearchIconProps) => (
  <div id="search-icon" style={{ width: '20px', height: '20px' }}>
    {children}
  </div>
)
